import * as React from 'react';
import { createFileRoute, useMatchRoute } from '@tanstack/react-router';
import { useEffect, useState } from 'react';

import { z } from 'zod';

import {
  Clause,
  endpointObligationsGET,
} from '~/api/def/endpoints/obligationsEndpoint';
import { useAuth } from '@clerk/clerk-react';
import { useHierarchyEndpoint } from '~/api/useHierarchyEndpoint';
import { TableAgObligations } from '~/components/ui/tables/ag/obligationsTable/TableAgObligations';

const documentSearchSchema = z.object({
  // page: z.number().catch(1),
  // tab: z.string().catch(""),
  // sort: z.enum(['newest', 'oldest', 'price']).catch('newest'),
});

export const Route = createFileRoute(
  '/_authLayout/obligations/list/$countryCode',
)({
  component: ObligationsItemComponent,
  validateSearch: documentSearchSchema,
});

function ObligationsItemComponent() {
  const match = useMatchRoute();
  const auth = useAuth();
  const countryCodeMatch = match({ to: '/obligations/list/$countryCode' });
  const { fundHierarchy } = useHierarchyEndpoint();
  const [clauses, setClauses] = useState<Clause[]>([]);

  const countryCode = countryCodeMatch ? countryCodeMatch.countryCode : false;
  useEffect(() => {
    if (countryCode && auth.isSignedIn && auth.isLoaded) {
      endpointObligationsGET(`/${countryCode}`).then((res) => {
        if (res) {
          setClauses(res.clauses);
        }
      });
    }
  }, [countryCode, auth.isLoaded, auth.isSignedIn]);

  if (countryCode) {
    return (
      // <div>{countryCode}</div>
      <TableAgObligations
        clauses={clauses}
        jurisdictionKey={countryCode}
        hierarchy={fundHierarchy}
      />
    );
  } else {
    <></>;
  }
}
